import { Icon, showDialogGenericInfo } from 'app/main/components';
import { ViewTableUtils } from 'app/main/components/page-layouts';

import { showDemsRecipientsClickDetailsDialog } from './dems-recipients/DemsRecipientsClickDetailsDialog';
import { showDemsRecipientsOpenDetailsDialog } from './dems-recipients/DemsRecipientsOpenDetailsDialog';

const DemsRecipientsModuleTableColumns = ({ dispatch, t }) => [
	{
		field: 'mail_title',
		headerName: t('DEMS_RECIPIENTS_COLUMN_MAIL'),
		minWidth: 200,
		flex: 4,
		renderCell: ({ value }) => {
			if (value) return ViewTableUtils.renderCellWithTooltip({ value });
			return ViewTableUtils.renderSquareChip({
				value: t('DELETED_VALUE'),
				backgroundColor: theme => theme.palette.error.main,
				icon: <Icon icon="trash-can" size={18} />
			});
		},
		hideable: false
	},
	{
		field: 'mail_table_uid',
		headerName: t('DEMS_RECIPIENTS_COLUMN_ITEM'),
		minWidth: 200,
		flex: 4,
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderCellWithTooltip({
				value:
					row.mail_table === 'people'
						? `${row.peop_title}${row.comp_title ? ` - ${row.comp_title}` : ''}`
						: row.mail_table === 'companies'
							? row.comp_title
							: row.user_title,
				to: { module: row.mail_table, uid: value }
			}),
		sortable: false
	},
	{
		field: 'derc_clicks_count',
		type: 'number',
		headerName: t('DEMS_RECIPIENTS_COLUMN_CLICKS'),
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderSquareChip({
				value: `${value || 0}`,
				backgroundColor: theme => theme.palette.success.main,
				icon: <Icon icon="cursor-default-click-outline" size={18} />,
				onClick:
					(row.derc_clicks || []).length > 0
						? () => dispatch(showDemsRecipientsClickDetailsDialog({ clicks: row.derc_clicks }))
						: undefined,
				disabled: !value
			})
	},
	{
		field: 'derc_open_count',
		type: 'number',
		headerName: t('DEMS_RECIPIENTS_COLUMN_OPENS'),
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderSquareChip({
				value: `${value || 0}`,
				backgroundColor: theme => theme.palette.warning.main,
				icon: <Icon icon="eye" size={18} />,
				onClick:
					(row.derc_opens || []).length > 0
						? () => dispatch(showDemsRecipientsOpenDetailsDialog({ opens: row.derc_opens }))
						: undefined,
				disabled: !value
			})
	},
	{
		field: 'mail_unsubscribed_dems_uid',
		type: 'number',
		headerName: t('DEMS_RECIPIENTS_COLUMN_UNSUBSCRIBED'),
		renderCell: ({ value, row }) =>
			value === row.dems_uid &&
			ViewTableUtils.renderSquareChip({
				value: t('DEMS_RECIPIENTS_COLUMN_UNSUBSCRIBED'),
				backgroundColor: theme => theme.palette.error.main
				// icon: <Icon icon="email-off" size={18} />
			})
	},
	{
		field: 'derc_bounce_type',
		type: 'number',
		headerName: t('DEMS_RECIPIENTS_COLUMN_BOUNCE'),
		renderCell: ({ value }) =>
			ViewTableUtils.renderSquareChip({
				value,
				icon: <Icon icon="alert" size={18} />,
				onClick: () =>
					dispatch(
						showDialogGenericInfo({
							title: t(`DIALOG_INFO_${value}_TITLE`),
							content: t(`DIALOG_INFO_${value}_TEXT`)
						})
					)
			})
	}
];

export default DemsRecipientsModuleTableColumns;
